// extracted by mini-css-extract-plugin
export default {"main-menu":"Header_main-menu__+WDJ1"};